import { enterpriseApiSlice } from "./index";
import { CompanyInfoMap } from "../Model/Api/CompanyObjects";

export const companyApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCompanyInfos: builder.query({
      query: () => ({
        url: "/company/info",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["CompanyInfos"],
      transformResponse: (response) => new CompanyInfoMap(response),
    }),
  }),
  overrideExisting: false,
});

export const { useFetchCompanyInfosQuery } = companyApi;
